import React, { useState } from 'react';

import PropTypes from 'prop-types';

// Components
import { Mui } from 'components';

function Popover({ actions }) {
  // States
  const [anchorEl, setAnchorEl] = useState(null);

  // Constants
  const hasActions = !!actions?.length;

  return (
    <>
      <Mui.Tooltip title={hasActions ? 'Ações' : 'Nenhuma ação disponível'}>
        <span>
          <Mui.IconButton
            disabled={!hasActions}
            onClick={e => {
              e.stopPropagation();
              setAnchorEl(e.currentTarget);
            }}>
            <Mui.Icon>more_horiz</Mui.Icon>
          </Mui.IconButton>
        </span>
      </Mui.Tooltip>
      <Mui.Popover
        anchorEl={anchorEl}
        anchorPosition={{ top: 0, left: 0 }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        open={!!anchorEl}
        onClose={() => setAnchorEl(null)}>
        <Mui.List style={{ padding: 0 }}>
          {actions.map((item, index) => (
            <Mui.ListItem
              key={item.key}
              button
              divider={index < actions.length - 1}
              onClick={e => {
                e.stopPropagation();
                item.action();
                setAnchorEl(null);
              }}>
              <Mui.ListItemIcon>
                <Mui.Icon>{item.icon}</Mui.Icon>
              </Mui.ListItemIcon>
              <Mui.ListItemText primary={item.title} />
            </Mui.ListItem>
          ))}
        </Mui.List>
      </Mui.Popover>
    </>
  );
}

Popover.propTypes = {
  actions: PropTypes.array,
};

export default Popover;
